import React from 'react'

import { useFromPage } from '../../../../providers/FromPageProvider'

import Button from 'react-bootstrap/Button'

import { SeatMapNavigation } from '../../../SeatMapNavigation'
import { useModal } from '../../../../providers/ModalProvider/ModalProvider'
import AssignTicketsModalContent from '../../../../providers/AssignToProvider/AssignTicketsModalContent/AssignTicketsModalContent'
import AssignTicketsModalContentV2 from '../../../../providers/AssignToProvider/AssignTicketsModalContent/AssignTicketsModalContentV2'
import { Error } from '../../../ModalContent'

export default function Navigation({
  eventPackage,
  isPackagePublished,
  hasPackageEnded,
  isMapDisabled,
  configuration,
  selectedSeatIds,
  handleShowResetConfiguration,
  savePackageInventory,
  handleGoBack,
  isDisabled,
  isSaving,
  data,
}) {
  const { openModal, closeModal } = useModal()
  const { isAssigningToFan } = useFromPage()

  const openAssignModal = () => {
    const GASectionsSelected = Object.values(selectedSeatIds?.gaSeats || {})
    const seatsSelected = Object.values(selectedSeatIds?.seats || {})

    // This is dumb
    if (GASectionsSelected.length > 1) {
      openModal(
        Error,
        {
          title: 'Cannot Assign Seats',
          description:
            'You can only assign seats from one GA section at a time...',
          onClose: closeModal,
        },
        { className: 'modal-sm' }
      )
      return
    }

    // This is also dumb
    if (GASectionsSelected.length > 0 && seatsSelected.length > 0) {
      openModal(
        Error,
        {
          title: 'Cannot Assign Seats',
          description:
            'You can only assign seats from either GA or seated sections at a time...',
          onClose: closeModal,
        },
        {},
        { className: 'modal-sm' }
      )
      return
    }

    openModal(
      AssignTicketsModalContent,
      {
        event: undefined,
        eventPackage,
        selectedSeatIds,
        data,
      },
      { className: 'modal-xl', contentClassName: 'h-md' }
    )
  }

  const openAssignModalV2 = () => {
    openModal(
      AssignTicketsModalContentV2,
      {
        event: undefined,
        eventPackage,
        selectedSeatIds,
        data,
      },
      { className: 'modal-xl', contentClassName: '' }
    )
  }

  const getButton = () => {
    return isAssigningToFan ? (
      <Button
        onClick={openAssignModalV2}
        disabled={
          isMapDisabled ||
          !selectedSeatIds ||
          Object.keys(selectedSeatIds)?.length === 0
        }
      >
        Assign to fan
      </Button>
    ) : (
      <Button
        onClick={() => {
          if (isSaving) return
          savePackageInventory()
        }}
        className={`btn-width ${isSaving ? '' : 'btn-width-md--flex-item'}`}
        disabled={
          isDisabled ||
          isMapDisabled ||
          !selectedSeatIds ||
          Object.keys(selectedSeatIds)?.length === 0 ||
          isSaving
        }
        aria-busy={isSaving}
        aria-live="polite"
        data-testid="package-seatmap-save"
      >
        {isSaving ? 'Saving Seat Map...' : 'Save & Continue'}
      </Button>
    )
  }

  return (
    <SeatMapNavigation
      isEvent={false}
      eventPackage={eventPackage}
      configuration={configuration}
      showReset={!isAssigningToFan}
      isDisabled={isPackagePublished || hasPackageEnded}
      handleLeave={handleGoBack}
      handleShowReset={handleShowResetConfiguration}
      getButton={getButton}
    >
      {/* <Button
        onClick={openAssignModalV2}
        disabled={
          isDisabled ||
          isMapDisabled ||
          !selectedSeatIds ||
          Object.keys(selectedSeatIds)?.length === 0
        }
        className={`${process.env.NODE_ENV !== "production" ? "" : "opacity-0"}`}
      >
        Assign tickets V2
      </Button> */}
    </SeatMapNavigation>
  )
}
